import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { jobApplicationsApi } from "../../api/endpoints";

export function useJobApplications() {
  return useQuery({
    queryKey: ["job-applications"],
    queryFn: () => jobApplicationsApi.list().then((r) => r.data),
  });
}

export function useDeleteJobApplication() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => jobApplicationsApi.delete(id).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["job-applications"] }),
  });
}
